import { render } from "./CompanyList-Customers.vue?vue&type=template&id=0e0d1ebb&ts=true"
import script from "./CompanyList-Customers.vue?vue&type=script&lang=ts"
export * from "./CompanyList-Customers.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__